import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"

export default class EmpresaFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombre: '',
                codigo: '',
                nit: '',
                razon_social: '',
                direccion: '',
                codigo_establecimiento: '',
                telefono: '0',
                departamento: '',
                municipio: '',
                estado: true
            },
            colapsar: true,
            camposRequeridos: [],
            departamentos: [],
            municipios: [],
            ubicaciones: [],
        };
        this.actualizarValores = this.actualizarValores.bind(this);
        this.obtenerMunicipios = this.obtenerMunicipios.bind(this);
        this.controladorCambiosDepartamento = this.controladorCambiosDepartamento.bind(this);
    }

    componentDidMount() {
        const { registro } = this.state;
        let idDepartamento = null;

        for (const key in registro) {
            if (registro[key] == null) {
                registro[key] = "";
            }
            if (key === 'departamento') {
                idDepartamento = registro[key];
            }
        }

        this.obtenerDepartamento(idDepartamento);
    }

    obtenerDepartamento(idDepartamento) {
        this.apiRest.get('/territorioTipo/DEPARTAMENTO').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ departamentos: respuesta.data });
                this.obtenerMunicipios(idDepartamento);
            }
        });
    }

    obtenerMunicipios(idDepartamento) {
        if (_valid(idDepartamento)) {
            this.apiRest.get('/territorioPadre/' + idDepartamento).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ municipios: respuesta.data });
                    this.setState(prevState => ({
                        registro: { ...prevState.registro, departamento: idDepartamento }
                    }));
                }
            });
        }
    }

    controladorCambiosDepartamento = ({ target: { name, value } }) => {
        this.obtenerMunicipios(value);
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (_valid(registro.id)) {
                this.apiRest.put('/empresa/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/empresaListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.apiRest.post('/empresa', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/empresaListado');
                        this.setState({ registro: resultado.data });
                        this.obtenerDepartamento();
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const { camposRequeridos } = this.state;
        const { codigo, nombre, razon_social, nit, direccion, municipio, departamento } = this.state.registro;
        let contador = 0;

        if (!_valid(codigo)) {
            camposRequeridos.push("codigo");
        }else{
            contador +=1;
        }
        if (!_valid(nombre)) {
            camposRequeridos.push("nombre");
        }else{
            contador +=1;
        }
        if (!_valid(nit)) {
            camposRequeridos.push("nit");
        }else{
            contador +=1;
        }
        if (!_valid(direccion)) {
            camposRequeridos.push("direccion");
        }else{
            contador +=1;
        }
        if (!_valid(municipio)) {
            camposRequeridos.push("municipio");
        }else{
            contador +=1;
        }
        if (!_valid(departamento)) {
            camposRequeridos.push("departamento");
        }else{
            contador +=1;
        }
        if(!_valid(razon_social)){
            camposRequeridos.push("razon social");
        }else{
            contador +=1;
        }


        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);
        if(contador === 7){
            return true;
        }else{
            return false;
        }
    }

    render() {
        const { registro, colapsar, camposRequeridos, departamentos, municipios } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Empresa" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Datos de la empresa</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="nombre"
                                                                        className="form-label"
                                                                    >
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="codigo"
                                                                        className="form-label"
                                                                    >
                                                                        Código
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.codigo}
                                                                        onChange={this.actualizarValores}
                                                                        name="codigo"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa código"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="nit"
                                                                        className="form-label"
                                                                    >
                                                                        NIT
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nit}
                                                                        onChange={this.actualizarValores}
                                                                        name="nit"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa nit"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="razon_social"
                                                                        className="form-label"
                                                                    >
                                                                        Razon Social
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.razon_social}
                                                                        onChange={this.actualizarValores}
                                                                        name="razon_social"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa razon social"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="direccion"
                                                                        className="form-label"
                                                                    >
                                                                        Dirección
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.direccion}
                                                                        onChange={this.actualizarValores}
                                                                        name="direccion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa dirección"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="codigo_establecimiento"
                                                                        className="form-label"
                                                                    >
                                                                        Código de establecimiento
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.codigo_establecimiento}
                                                                        onChange={this.actualizarValores}
                                                                        name="codigo_establecimiento"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa código de establecimiento"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label
                                                                        htmlFor="telefono"
                                                                        className="form-label"
                                                                    >
                                                                        Teléfono
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.telefono}
                                                                        onChange={this.actualizarValores}
                                                                        name="telefono"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa teléfono"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Departamento
                                                                    </Label>
                                                                    <select
                                                                        value={registro.departamento}
                                                                        onChange={this.controladorCambiosDepartamento}
                                                                        name="departamento"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {departamentos.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Municipio
                                                                    </Label>
                                                                    <select
                                                                        value={registro.municipio}
                                                                        onChange={this.actualizarValores}
                                                                        name="municipio"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {municipios.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Estado
                                                                    </Label>
                                                                    <select
                                                                        value={registro.estado}
                                                                        onChange={this.actualizarValores}
                                                                        name="estado"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="true">Activo</option>
                                                                        <option value="false">Inactivo</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/empresaListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}